"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = require("../component");

var _uid = require("../utils/uid");

var _styles = require("../styles");

var _List = _interopRequireDefault(require("./List"));

var _context = require("./context");

var _is = require("../utils/is");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Item =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Item, _PureComponent);

  function Item(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.id = props.path + "," + (0, _uid.getUidStr)();

    var key = _this.getKey(props);

    var _props$bindItem = props.bindItem(_this.id, _this.update.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.updateOpen.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.updateInPath.bind(_assertThisInitialized(_assertThisInitialized(_this)))),
        activeUpdate = _props$bindItem[0],
        openUpdate = _props$bindItem[1],
        inPathUpdate = _props$bindItem[2];

    _this.state = {
      open: openUpdate(key),
      isActive: activeUpdate(_this.id, props.data),
      inPath: inPathUpdate(_this.id),
      isHighLight: false
    };
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleMouseEnter = _this.handleToggle.bind(_assertThisInitialized(_assertThisInitialized(_this)), true);
    _this.handleMouseLeave = _this.handleToggle.bind(_assertThisInitialized(_assertThisInitialized(_this)), false);
    return _this;
  }

  var _proto = Item.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    _PureComponent.prototype.componentWillUnmount.call(this);

    this.props.unbindItem(this.id);
    this.unbindDocumentEvent();
  };

  _proto.getKey = function getKey(props) {
    if (props === void 0) {
      props = this.props;
    }

    return (0, _uid.getKey)(props.data, props.keygen, props.index);
  };

  _proto.bindElement = function bindElement(el) {
    this.element = el;
  };

  _proto.unbindDocumentEvent = function unbindDocumentEvent() {
    document.removeEventListener('click', this.handleMouseLeave);
  };

  _proto.update = function update(check, activePath) {
    var isActive = check(this.id, this.props.data);
    var isHighLight = activePath && isActive ? activePath.indexOf(this.id) > -1 : false;
    this.setState({
      isActive: isActive,
      isHighLight: isHighLight
    });
  };

  _proto.updateOpen = function updateOpen(check) {
    var isOpen = check(this.getKey());
    this.setState({
      open: isOpen
    });
  };

  _proto.updateInPath = function updateInPath(check) {
    var inPath = check(this.id);
    this.setState({
      inPath: inPath
    });
  };

  _proto.handleToggle = function handleToggle(open) {
    var toggleOpenKeys = this.props.toggleOpenKeys;
    var key = this.getKey();
    if (this.toggleTimer) clearTimeout(this.toggleTimer);

    if (open) {
      toggleOpenKeys(key, true);
      document.addEventListener('click', this.handleMouseLeave);
    } else {
      this.toggleTimer = setTimeout(function () {
        toggleOpenKeys(key, false);
      }, 200);
      this.unbindDocumentEvent();
    }
  };

  _proto.handleClick = function handleClick() {
    var _this$props = this.props,
        data = _this$props.data,
        onClick = _this$props.onClick,
        mode = _this$props.mode,
        toggleOpenKeys = _this$props.toggleOpenKeys;
    if (data.disabled) return;

    if (mode === 'inline' && data.children) {
      toggleOpenKeys(this.getKey(), !this.state.open);
    }

    if (typeof data.onClick === 'function') {
      data.onClick(this.id, data);
    } else if ((!data.children || data.onClick === true) && typeof onClick === 'function') {
      onClick(this.id, data);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        data = _this$props2.data,
        renderItem = _this$props2.renderItem,
        mode = _this$props2.mode,
        keygen = _this$props2.keygen,
        level = _this$props2.level,
        onClick = _this$props2.onClick,
        inlineIndent = _this$props2.inlineIndent,
        disabled = _this$props2.disabled,
        toggleOpenKeys = _this$props2.toggleOpenKeys,
        bottomLine = _this$props2.bottomLine,
        topLine = _this$props2.topLine;
    var _this$state = this.state,
        open = _this$state.open,
        isActive = _this$state.isActive,
        isHighLight = _this$state.isHighLight,
        inPath = _this$state.inPath;
    var dChildren = data.children;
    var children = dChildren || [];
    var isDisabled = typeof disabled === 'function' ? disabled(data) : disabled;
    var isUp = false;

    if (mode === 'vertical' && this.element) {
      isUp = this.element.getBoundingClientRect().bottom - topLine > (bottomLine - topLine) / 2;
    }

    var className = (0, _styles.menuClass)('item', isDisabled === true && 'disabled', children.length > 0 ? 'has-children' : 'no-children', isActive && 'active', open && 'open', isUp && 'open-up', isHighLight && 'highlight', inPath && 'in-path');
    var style = {};
    var events = {};

    if (mode === 'inline') {
      style.paddingLeft = 20 + level * inlineIndent;
    } else {
      events.onMouseEnter = this.handleMouseEnter;
      events.onMouseLeave = this.handleMouseLeave;
    }

    var item = renderItem(data);

    if ((0, _is.isLink)(item)) {
      var mergeClass = (0, _classnames.default)((0, _styles.menuClass)('title'), item.props && item.props.className);
      var mergeStyle = Object.assign({}, style, item.props && item.props.style);
      item = (0, _react.cloneElement)(item, {
        className: mergeClass,
        style: mergeStyle
      });
    } else {
      item = _react.default.createElement("a", {
        href: "javascript:;",
        className: (0, _styles.menuClass)('title'),
        style: style,
        onClick: this.handleClick
      }, item);
    }

    return _react.default.createElement("li", _extends({
      className: className
    }, events, {
      ref: this.bindElement
    }), item, children.length > 0 && _react.default.createElement(_List.default, {
      data: children,
      disabled: disabled,
      renderItem: renderItem,
      keygen: keygen,
      inlineIndent: mode === 'horizontal' ? 0 : inlineIndent,
      mode: mode === 'horizontal' ? 'inline' : mode,
      onClick: onClick,
      path: this.id,
      level: level + 1,
      open: open,
      toggleOpenKeys: toggleOpenKeys
    }));
  };

  return Item;
}(_component.PureComponent);

Item.propTypes = {
  bindItem: _propTypes.default.func,
  bottomLine: _propTypes.default.number,
  topLine: _propTypes.default.number,
  data: _propTypes.default.object,
  disabled: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool]),
  index: _propTypes.default.number,
  inlineIndent: _propTypes.default.number,
  level: _propTypes.default.number,
  keygen: _propTypes.default.any,
  mode: _propTypes.default.string,
  onClick: _propTypes.default.func,
  path: _propTypes.default.string,
  renderItem: _propTypes.default.func,
  toggleOpenKeys: _propTypes.default.func,
  unbindItem: _propTypes.default.func
};

var _default = (0, _context.consumer)(Item);

exports.default = _default;